<div class="tt-c-review">
  <tt-grid-layout :layout="currentLayout" classPrefix="tt-c-review" class="tt-c-review__content">
    <template v-if="isRelatedReview && !isSlotHidden('relatedProduct')" v-slot:relatedProduct>
      <tt-product-about :catItem="review.catItem" class="tt-c-review__product tt-u-mb--md" imageSize="SS"></tt-product-about>
    </template>
    <template v-if="!isSlotHidden('stars')" v-slot:stars>
      <tt-rating-stars :rating="review.rating" starSize="lg" class="tt-c-review__rating tt-u-mb--sm"></tt-rating-stars>
    </template>
    <template v-if="!isSlotHidden('reviewDate')" v-slot:reviewDate>
      <div class="tt-c-review__date tt-u-mb--sm">{{ reviewDate }}</div>
    </template>
    <template v-if="!isSlotHidden('reviewTitle') && review.title" v-slot:reviewTitle>
      <div :id="titleId" class="tt-c-review__heading tt-u-mb--sm" role="heading" :aria-level="heading.level"><div class="tt-c-review__heading-text" v-html="heading.text"></div></div>
    </template>
    <template v-if="review.media && review.media.length > 0 && !isSlotHidden('media')" v-slot:media>
      <div class="tt-c-review__media tt-u-mb--md">
        <a v-for="(mediaItem, index) in review.media" href="" @click.prevent="openMediaModal(index)"
          class="tt-c-review__media-link"
          aria-haspopup="true" :key="mediaItem.id" rel="nofollow">
          <tt-media-thumb :altText="mediaLinkTitle(mediaItem)" :media="mediaItem" :size="mediaSize" class="tt-c-review__media-item"></tt-media-thumb>
        </a>
      </div>
    </template>
    <template v-if="!isSlotHidden('reviewText')" v-slot:reviewText>
      <div class="tt-c-review__text">
        <div v-for="(update, i) in reviewTexts" class="tt-c-review__text-wrap">
          <div class="tt-c-review__text-content-wrapper tt-u-mb--md">
            <span class="tt-c-review__text-content" v-html="update.text"></span>
            <template v-if="update.hasTruncatedText && !update.isExpanded">&hellip;</template> <tt-button v-if="update.hasTruncatedText"
                                                                                                          ref="readMoreBtn"
                                                                                                          type="link"
                                                                                                          :aria-label="$msg(update.isExpanded ? 'review.readLess.aria' : 'review.readMore.aria', [formatUserName(review.user)])"
                                                                                                          :aria-describedby="titleId"
                                                                                                          class="tt-c-review__text-expand"
                                                                                                          @click.prevent="toggleExpandText(i)"
                                                                                                          v-html="$msg(update.isExpanded ? 'review.readLess' : 'review.readMore')"></tt-button>
          </div>
        </div>
        <div v-if="isTranslated" class="tt-c-review__translatedby tt-u-mb--md">
          <a href="http://translate.google.com/" target="_blank">
            <img src="https://wac.edgecastcdn.net/001A39/prod/custom/google/greyscale-short.svg"
                 alt="translated by google" class="tt-c-review__translate-logo">
          </a>          
        </div>
      </div>
    </template>
    <template v-if="!isSlotHidden('byline')" v-slot:byline>
      <tt-review-byline :item="review" :showPurchaserBadge="showPurchaserBadge" ugcType="r" class="tt-c-review__byline tt-u-mb--lg"></tt-review-byline>
    </template>
    <template v-if="profileAttributes && profileAttributes.length > 0 && !isSlotHidden('profileAttributes')" v-slot:profileAttributes>
      <div class="tt-c-review__profile-attributes tt-c-profile-attributes tt-u-mb--lg" :class="{'tt-c-profile-attributes--stacked': areProfileAttributesStacked}">
        <div v-for="attribute in profileAttributes" class="tt-c-profile-attributes__item">
          <div class="tt-c-profile-attributes__property tt-u-mb--xs" v-html="attribute.label"></div>
          <div class="tt-c-profile-attributes__value" v-html="attribute.value"></div>
        </div>
      </div>
    </template>
    <template v-if="review.responsesBySource.length > 0 && !isSlotHidden('reviewResponses')" v-slot:reviewResponses>
      <tt-review-responses :responsesBySource="review.responsesBySource"></tt-review-responses>
    </template>
    <template v-for="(dim, i) in reviewDimensions" v-slot:[dim.slotName]>
      <tt-dimension :type="dim.type"
                    :label="dim.dimensionLabel"
                    :value="dim.value"
                    :valueLabels="dim.valueLabels"
                    :key="dim.label"></tt-dimension>
    </template>
    <template v-if="translatable" v-slot:translate>
      <div class="tt-c-review__translate tt-u-mb--md">
        <tt-button class="tt-c-review__translate-link"
                  type="link"
                  @click="translateReview"
                  v-html="translateMsg"></tt-button>                  
      </div>
    </template>
    <template v-if="review.purchaseDateFormatted && !isSlotHidden('purchasedOn')" v-slot:purchasedOn>
      <div class="tt-c-review__purchased tt-u-mb--sm" v-html="$msg('review.purchasedOn', [review.purchaseDateFormatted])"></div>
    </template>
    <template v-if="syndicationAttribution && !isSlotHidden('syndication')" v-slot:syndication>
      <div class="tt-c-review__syndication tt-u-mb--xl" v-html="syndicationAttribution"></div>
    </template>
    <template v-if="review.incentivized && !isSlotHidden('incentivized')" v-slot:incentivized>
      <div class="tt-c-review__incentivized tt-u-mb--sm" v-html="$msg('review.incentivized')"></div>
    </template>
    <template v-if="!isSlotHidden('toolbar')" v-slot:toolbar>
      <tt-review-toolbar class="tt-u-mb--xs" :review="review" :downVotes="review.downVotes" :upVotes="review.upVotes"></tt-review-toolbar>
    </template>
    <template v-if="displayShowDetails" v-slot:showDetails>
      <div class="tt-c-review__expander tt-o-expander tt-o-expander--with-dashed-border">
        <tt-button type="toolbar" @click="onShowDetailsClick" class="tt-o-expander__button"><tt-icon name="options-expand" size="sm" class="tt-c-reviews-summary__expander-icon"></tt-icon><span class="tt-o-expander__text" v-html="$msg('review.showDetails')"></span></tt-button>
      </div>
    </template>
  </tt-grid-layout>
</div>
